<ng-container *ngIf="isMatched; else protectWrapper">
    <header class="admin-header fixed-top d-flex align-items-center">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="header-wrap col-xl-11 d-flex align-items-center justify-content-between">
                    <a class="company-logo" [href]="env.publicWeb">
                        <img
                            src="assets/images/EoW-Horizontal-logo_TM_noBackgroundcolor.svg"
                            alt="logo"
                            class="img-fluid"
                        />
                    </a>
                    <div class="d-flex align-items-center">
                        <a class="btn-raised" [href]="env.ssoWeb">
                            {{ 'login' | translate }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <div class="main">
        <router-outlet> </router-outlet>
    </div>
    <ng-container>
        <app-footer></app-footer>
    </ng-container>
</ng-container>

<ng-template #protectWrapper>
    <div class="protect-wrapper">
        <img
            src="assets/images/EoW-Horizontal-logo_TM_noBackgroundcolor.svg"
            alt="logo"
            class="img-fluid"
            class="w-25"
        /><br />
        <input
            pInputText
            type="password"
            [(ngModel)]="password"
            (ngModelChange)="onCheckPassword()"
            placeholder="{{ 'enter_password' | translate }}"
        />
        <div class="d-none">
            <router-outlet></router-outlet>
        </div>
    </div>
</ng-template>
